// extracted by mini-css-extract-plugin
export default {"modal_animation_duration":"200ms","controls":"onfido-sdk-ui-DocumentMultiFrame-controls","btn":"onfido-sdk-ui-DocumentMultiFrame-btn"};